import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ORIGIN = "https://sebastians-produce.com";

const setAttr = (selector, attr, value) => {
  const el = document.querySelector(selector);
  if (el && value) el.setAttribute(attr, value);
};

export const Seo = ({ title, description }) => {
  const { pathname } = useLocation();
  useEffect(() => {
    const url = `${ORIGIN}${pathname === "/" ? "/" : pathname}`;
    document.title = title;
    setAttr('meta[name="description"]', "content", description);
    setAttr('meta[property="og:title"]', "content", title);
    setAttr('meta[property="og:description"]', "content", description);
    setAttr('meta[name="twitter:title"]', "content", title);
    setAttr('meta[name="twitter:description"]', "content", description);
    setAttr('meta[property="og:url"]', "content", url);
    setAttr('link[rel="canonical"]', "href", url);
  }, [title, description, pathname]);
  return null;
};
